import {useEffect, useState} from 'react';
import dynamic, {Loader} from 'next/dynamic';
import {useRouter} from "next/router";

const useDynamicModal = (modalImport: Loader<any>, modalState?: [boolean, (state: boolean) => void]) => {
	const [ModalComponent, setModalComponent] = useState<any>(null);
	const [modalOpenState, setModalOpenState] = modalState || useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const router = useRouter();

	useEffect(() => {
		try
		{
			if (modalOpenState)
			{
				// Preload the modal component dynamically
				if (!ModalComponent)
				{
					setModalComponent(
						dynamic(modalImport, {
							loading: () => {
								console.log("Loading dynamic modal component...")
								useEffect(() => {
									router.events.emit('routeChangeStart', router.asPath);
									setLoading(true);
									return () => {
										router.events.emit('routeChangeComplete', router.asPath);
										setLoading(false);
									}
								}, [setLoading]);

								return null
							},
							ssr: false,
						})
					);
				}
			}
		}
		catch (e)
		{
			console.error(e);
		}
		finally
		{
			// setLoading(false);
		}
	}, [modalOpenState, ModalComponent]);

	const openModal = () => setModalOpenState(true);
	const closeModal = () => setModalOpenState(false);

	return [
		ModalComponent,
		[modalOpenState, setModalOpenState],
		openModal,
		closeModal,
		loading
	]
};

export default useDynamicModal;
